import React, { useEffect, useState } from 'react'
import './contract-details.less'
import { setHeader } from '@/util/set-header'
import { List, Toast } from 'antd-mobile'
import { contractDetailApi } from '@/api/user-infomation'

const Item = List.Item
function ContractDetails({ match }: any) {
  const { id } = match.params
  const [data, setData]: any = useState()
  useEffect(() => {
    setHeader({ title: '合同明细' })

    const fetchContractDetail = async () => {
      Toast.loading('加载中', 0)
      const { data } = await contractDetailApi({ id })
      Toast.hide()
      if (data.code !== 'SUCCESS') {
        Toast.info(data.msg, 3)
        return false
      }
      setData(data.data)
    }
    //获取合同明细
    fetchContractDetail()
  }, [id])
  return (
    <div className="contract-details">
      <List>
        {data?.map((item: any, i: number) => {
          if (!item.title) {
            return false
          }

          return (
            <div key={i} className={item.detail ? '' : 'con-border'}>
              <Item
                wrap
                extra={<span className="f_color_black ">{item.detail}</span>}
                data-seed="logId"
              >
                {item.title}
              </Item>
            </div>
          )
        })}
      </List>
    </div>
  )
}

export default ContractDetails
